import { defineComponent } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CloseButton",
  emits: ["close"],
  setup(__props, { emit: emits }) {
    const onClose = () => {
      emits("close");
    };
    return { __sfc: true, emits, onClose };
  }
});

export { _sfc_main as default };
